// Records → Coverage Map. Standalone route so the map has the full
// viewport width; sits under Records in the sidebar between Patients
// and Reports. See ../components/records/CoverageMap.tsx for the
// implementation.
//
// Role gate: same as Patients / Reports / Audit log — pharmacy_admin
// and pharmacy_staff. dispatchers land here indirectly via the
// role-aware landing route if a link is followed; the sidebar doesn't
// render the link for them because coverage aggregation is a records
// / compliance surface. platform_admin sees it via the implicit
// bypass in the guards.

import { createFileRoute } from '@tanstack/react-router';
import { requireUserType } from '../lib/auth/guards';
import { useSetPageHeader } from '../components/layout/PageHeaderContext';
import { CoverageMap } from '../components/records/CoverageMap';

export const Route = createFileRoute('/_authenticated/coverage-map')({
  beforeLoad: async () => {
    await requireUserType({ allowed: ['pharmacy_admin', 'pharmacy_staff'] });
  },
  component: CoverageMapPage,
});

function CoverageMapPage(): JSX.Element {
  // Drop the standard title band so the map takes full page height.
  // CoverageMap renders its own compact header + filter row inline.
  // Title is still required by the header context type; supplied for
  // the tab / a11y / breadcrumb even though the top bar is hidden.
  useSetPageHeader({ title: 'Coverage Map', hideTopBar: true });
  return <CoverageMap />;
}
